

import cnLists from './chinese-pynsimpl'

let dyKeyboard =  {
    zn_en: {
        keyList: [
            [
                {
                    dataKey: '1',
                    dataShiftKey: '!',
                    type: 'set',
                    className: ''
                },
                {
                    dataKey: '2',
                    dataShiftKey: '@',
                    type: 'set',
                    className: ''
                },
                {
                    dataKey: '3',
                    dataShiftKey: '#',
                    type: 'set',
                    className: ''
                },
                {
                    dataKey: '4',
                    dataShiftKey: '$',
                    type: 'set',
                    className: ''
                },
                {
                    dataKey: '5',
                    dataShiftKey: '%',
                    type: 'set',
                    className: ''
                },
                {
                    dataKey: '6',
                    dataShiftKey: '^',
                    type: 'set',
                    className: ''
                },
                {
                    dataKey: '7',
                    dataShiftKey: '&',
                    type: 'set',
                    className: ''
                },
                {
                    dataKey: '8',
                    dataShiftKey: '*',
                    type: 'set',
                    className: ''
                },
                {
                    dataKey: '9',
                    dataShiftKey: '(',
                    type: 'set',
                    className: ''
                },
                {
                    dataKey: '0',
                    dataShiftKey: ')',
                    type: 'set',
                    className: ''
                },
            ],
            [
                {
                    dataKey: 'q',
                    dataShiftKey: 'Q',
                    type: 'add',
                    className: ''
                },
                {
                    dataKey: 'w',
                    dataShiftKey: 'W',
                    type: 'add',
                    className: ''
                },
                {
                    dataKey: 'e',
                    dataShiftKey: 'E',
                    type: 'add',
                    className: ''
                },
                {
                    dataKey: 'r',
                    dataShiftKey: 'R',
                    type: 'add',
                    className: ''
                },
                {
                    dataKey: 't',
                    dataShiftKey: 'T',
                    type: 'add',
                    className: ''
                },
                {
                    dataKey: 'y',
                    dataShiftKey: 'Y',
                    type: 'add',
                    className: ''
                },
                {
                    dataKey: 'u',
                    dataShiftKey: 'U',
                    type: 'add',
                    className: ''
                },
                {
                    dataKey: 'i',
                    dataShiftKey: 'I',
                    type: 'add',
                    className: ''
                },
                {
                    dataKey: 'o',
                    dataShiftKey: 'O',
                    type: 'add',
                    className: ''
                },
                {
                    dataKey: 'p',
                    dataShiftKey: 'P',
                    type: 'add',
                    className: ''
                },
            ],
            [
                {
                    dataKey: 'a',
                    dataShiftKey: 'A',
                    type: 'add',
                    className: ''
                },
                {
                    dataKey: 's',
                    dataShiftKey: 'S',
                    type: 'add',
                    className: ''
                },
                {
                    dataKey: 'd',
                    dataShiftKey: 'D',
                    type: 'add',
                    className: ''
                },
                {
                    dataKey: 'f',
                    dataShiftKey: 'F',
                    type: 'add',
                    className: ''
                },
                {
                    dataKey: 'g',
                    dataShiftKey: 'G',
                    type: 'add',
                    className: ''
                },
                {
                    dataKey: 'h',
                    dataShiftKey: 'H',
                    type: 'add',
                    className: ''
                },
                {
                    dataKey: 'j',
                    dataShiftKey: 'J',
                    type: 'add',
                    className: ''
                },
                {
                    dataKey: 'k',
                    dataShiftKey: 'K',
                    type: 'add',
                    className: ''
                },
                {
                    dataKey: 'l',
                    dataShiftKey: 'L',
                    type: 'add',
                    className: ''
                },
            ],
            [
                {
                    dataKey: 'z',
                    dataShiftKey: 'Z',
                    type: 'add',
                    className: ''
                },
                {
                    dataKey: 'x',
                    dataShiftKey: 'X',
                    type: 'add',
                    className: ''
                },
                {
                    dataKey: 'c',
                    dataShiftKey: 'C',
                    type: 'add',
                    className: ''
                },
                {
                    dataKey: 'v',
                    dataShiftKey: 'V',
                    type: 'add',
                    className: ''
                },
                {
                    dataKey: 'b',
                    dataShiftKey: 'B',
                    type: 'add',
                    className: ''
                },
                {
                    dataKey: 'n',
                    dataShiftKey: 'N',
                    type: 'add',
                    className: ''
                },
                {
                    dataKey: 'm',
                    dataShiftKey: 'M',
                    type: 'add',
                    className: ''
                },
            ],
            [
                {
                    dataKey: '英',
                    type: 'shift',
                    className: 'shift',
                    shiftClassName: 'active',
                    shiftClassName2: 'active2'
                },
                {
                    dataKey: ' ',
                    type: 'kongge',
                    className: 'kongge'
                },
                {
                    dataKey: '符',
                    type: 'symbolTable',
                    className: 'symbolTable',
                    clickChange: 'fuhao',
                },
                {
                    dataKey: '123',
                    type: 'number',
                    className: 'number',
                    clickChange: 'number',
                },
                {
                    dataKey: '←',
                    type: 'del',
                    className: 'del'
                },
            ],
        ]
    },
    fuhao: {
        keyList: [
            [
                {
                    dataKey: '~',
                    dataShiftKey: '~',
                    type: 'set',
                    className: ''
                },
                {
                    dataKey: '!',
                    dataShiftKey: '！',
                    type: 'set',
                    className: ''
                },
                {
                    dataKey: '@',
                    dataShiftKey: '@',
                    type: 'set',
                    className: ''
                },
                {
                    dataKey: '#',
                    dataShiftKey: '#',
                    type: 'set',
                    className: ''
                },
                {
                    dataKey: '$',
                    dataShiftKey: '￥',
                    type: 'set',
                    className: ''
                },
                {
                    dataKey: '%',
                    type: 'set',
                    className: ''
                },
                {
                    dataKey: '^',
                    dataShiftKey: '……',
                    type: 'set',
                    className: ''
                },
                {
                    dataKey: '&',
                    type: 'set',
                    className: ''
                },
            ],
            [
                {
                    dataKey: '_',
                    dataShiftKey: '—',
                    type: 'set',
                    className: ''
                },
                {
                    dataKey: '=',
                    type: 'set',
                    className: ''
                },
                {
                    dataKey: '+',
                    type: 'set',
                    className: ''
                },
                {
                    dataKey: '-',
                    type: 'set',
                    className: ''
                },
                {
                    dataKey: '*',
                    dataShiftKey: '×',
                    type: 'set',
                    className: ''
                },
                {
                    dataKey: '/',
                    dataShiftKey: '÷',
                    type: 'set',
                    className: ''
                },
                {
                    dataKey: '{',
                    dataShiftKey: '{',
                    type: 'set',
                    className: ''
                },
                {
                    dataKey: '}',
                    dataShiftKey: '}',
                    type: 'set',
                    className: ''
                },
            ],
            [
                {
                    dataKey: '(',
                    dataShiftKey: '（',
                    type: 'set',
                    className: ''
                },
                {
                    dataKey: ')',
                    dataShiftKey: '）',
                    type: 'set',
                    className: ''
                },
                {
                    dataKey: '.',
                    dataShiftKey: '。',
                    type: 'set',
                    className: ''
                },
                {
                    dataKey: ';',
                    dataShiftKey: '；',
                    type: 'set',
                    className: ''
                },
                {
                    dataKey: ':',
                    dataShiftKey: '：',
                    type: 'set',
                    className: ''
                },
                {
                    dataKey: '\'',
                    dataShiftKey: '‘’',
                    type: 'set',
                    className: ''
                },
                {
                    dataKey: '\"',
                    dataShiftKey: '“”',
                    type: 'set',
                    className: ''
                },
                {
                    dataKey: '?',
                    dataShiftKey: '？',
                    type: 'set',
                    className: ''
                },
            ],
            [
                {
                    dataKey: 'shift',
                    type: 'shift',
                    className: 'shift',
                    shiftClassName: 'active',
                },
                {
                    dataKey: ',',
                    dataShiftKey: '，',
                    type: 'set',
                    className: ''
                },
                {
                    dataKey: '<',
                    dataShiftKey: '《',
                    type: 'set',
                    className: ''
                },
                {
                    dataKey: '>',
                    dataShiftKey: '》',
                    type: 'set',
                    className: ''
                },
                {
                    dataKey: '/',
                    dataShiftKey: '、',
                    type: 'set',
                    className: ''
                },
                {
                    dataKey: '中',
                    type: 'cn',
                    className: 'cn',
                    clickChange: 'zn_en',
                },
                {
                    dataKey: '←',
                    type: 'del',
                    className: 'del'
                },
            ]
        ]
    },
    number: {
        keyList: [
            [
                {
                    dataKey: '1',
                    type: 'set',
                    className: ''
                },
                {
                    dataKey: '2',
                    type: 'set',
                    className: ''
                },
                {
                    dataKey: '3',
                    type: 'set',
                    className: ''
                },
            ],
            [
                {
                    dataKey: '4',
                    type: 'set',
                    className: ''
                },
                {
                    dataKey: '5',
                    type: 'set',
                    className: ''
                },
                {
                    dataKey: '6',
                    type: 'set',
                    className: ''
                },
            ],
            [
                {
                    dataKey: '7',
                    type: 'set',
                    className: ''
                },
                {
                    dataKey: '8',
                    type: 'set',
                    className: ''
                },
                {
                    dataKey: '9',
                    type: 'set',
                    className: ''
                },
            ],
            [
                {
                    dataKey: '中',
                    type: 'cn',
                    className: 'cn',
                    clickChange: 'zn_en',
                },
                {
                    dataKey: '0',
                    type: 'set',
                    className: ''
                },
                {
                    dataKey: '←',
                    type: 'del',
                    className: 'del'
                },
            ]
        ]
    }
};

export default {
    name: "dyKeyboard",
    data() {
        return {
            el: null,
            cnLists: cnLists,
            dyKeyboard: dyKeyboard,
            delTimer1: null, // 首次延迟
            delTimer2: null, // 后续删除速度
            type: 'zn_en', // 键盘类型
            showTF: false, // 是否显示键盘
            shift: 0, // 上档键 0中文，1拼音，2大写拼音
            blurIndexStart: 0, // 失去焦点时的光标开始位置
            blurIndexEnd: 0, // 失去焦点时的光标结束位置
            textOK: '',//已经输入的值
            enIng: '', // 正在输入的拼音
            cnIng: '', // 正在候选的汉字
        }
    },
    watch: {
        textOK(val) {
            let _self = this;
            _self.el.value = val;
            _self.el.dispatchEvent(new Event("input"));//调用input事件使vue v-model绑定更新
        }
    },
    created() {
        let _self = this;
        // console.log(_self.dyKeyboard);
        // console.log(_self.dyKeyboard[_self.type].keyList);
    },
    methods: {
        // 初始化
        init(text,option) {
            let _self = this;
            _self.textOK = text || '';
            _self.blurIndexStart = option.blurIndexStart;
            _self.blurIndexEnd = option.blurIndexEnd;
            _self.enIng = '';
            _self.cnIng = '';
            _self.setSelectionRange();
        },
        // 显示键盘
        show(text, option) {
            let _self = this;
            _self.el = option.el;
            _self.showTF = true;
            _self.init(text, option);
        },
        // 隐藏键盘
        hide() {
            let _self = this;
            _self.showTF = false;
        },
        // 获取光标所在位置的index
        blurEvent(e) {
            let _self = this;
            _self.blurIndexStart = e.srcElement.selectionStart;
            _self.blurIndexEnd = e.srcElement.selectionEnd;
        },
        // 设置光标位置
        setSelectionRange() {
            let _self = this;
            _self.$refs.ipt.focus();
            let ipt = _self.$refs.ipt;
            _self.$nextTick(() => {
                ipt.setSelectionRange(_self.blurIndexStart, _self.blurIndexEnd);
            });
        },
        // 关闭键盘
        close() {
            let _self = this;
            _self.hide();
        },
        // 确认输入
        ok() {
            let _self = this;
            _self.hide();
        },
        // 点击键盘
        clickKey(item) {
            let _self = this;
            if (item.type === 'add') {// 如果是拼音
                if (_self.shift === 0) {
                    _self.enIng += item.dataKey;
                } else if (_self.shift === 1) {
                    _self.cnOKTextFn(item.dataKey);
                } else if (_self.shift === 2) {
                    _self.cnOKTextFn(item.dataShiftKey);
                }
            } else if (item.type === 'set') {// 如果是数字
                if (_self.shift === 0) {
                    _self.cnOKTextFn(item.dataKey);
                } else {
                    _self.cnOKTextFn(item.dataShiftKey || item.dataKey);
                }
            } else if (item.type === 'kongge') {// 如果是空格
                _self.konggeKey(item);
            } else if (item.type === 'del') { // 删除
                _self.delKey(item);
                clearTimeout(_self.delTimer1);
                _self.delTimer1 = null;
                // 长按连续删除
                _self.delTimer1 = setTimeout(() => {
                    clearTimeout(_self.delTimer1);
                    _self.delTimer1 = null;
                    _self.delTimer2 = setInterval(() => {
                        _self.delKey(item);
                    }, 70);
                }, 700);
            } else if (item.type === 'shift') {
                _self.shift++;
                // shift默认一级
                let shiftLevel = 1;
                // shift如果有两级
                if (item.shiftClassName2) {
                    shiftLevel = 2;
                }
                if (_self.shift > shiftLevel) {
                    _self.shift = 0;
                }
            }

            // 切换键盘
            if (item.clickChange) {
                _self.type = item.clickChange;
                _self.shift = 0;
            }

            _self.znFilter(_self.enIng);
        },
        // 鼠标抬起
        clickKeyEnd() {
            let _self = this;
            clearTimeout(_self.delTimer1);
            _self.delTimer1 = null;
            clearInterval(_self.delTimer2);
            _self.delTimer2 = null;
            _self.setSelectionRange();
        },
        // 鼠标离开
        clickKeyLeave() {
            let _self = this;
            clearTimeout(_self.delTimer1);
            _self.delTimer1 = null;
            clearInterval(_self.delTimer2);
            _self.delTimer2 = null;
        },
        // 空格按钮
        konggeKey(item) {
            let _self = this;
            let text = item.dataKey;
            if (_self.cnIng) {
                // 选择候选区的中文
                text = (_self.cnIng[0]);
            } else if (_self.enIng) {
                // 选择候选区的拼音
                text = (_self.enIng);
            }
            _self.cnOKTextFn(text);
        },
        // 删除按钮
        delKey() {
            let _self = this;
            // 如果拼音正在输入，删除拼音
            if (_self.enIng) {
                _self.enIng = _self.enIng.slice(0, _self.enIng.length - 1);
            } else {// 如果没有拼音，删除输入框中汉字
                // 相等：单光标删除，不等：区间删除，区间删除不用移动光标
                if (_self.blurIndexStart === _self.blurIndexEnd) {
                    _self.blurIndexStart--;
                    if (_self.blurIndexStart <= 0) {
                        _self.blurIndexStart = 0;
                    }
                }
                _self.cnOKTextFn('', 0);
            }
        },
        // 中文匹配
        znFilter(en) {
            let _self = this;
            _self.cnIng = _self.cnLists[en];
            _self.setSelectionRange();
        },
        // 选择中文
        cnOKTextFn(text = '', blurIndex = text.length) { // text文本，blurIndex光标位置
            let _self = this;
            _self.textOK =
                _self.textOK.slice(0, _self.blurIndexStart) +
                text +
                _self.textOK.slice(_self.blurIndexEnd, _self.textOK.length);
            _self.blurIndexStart += blurIndex;
            _self.blurIndexEnd = _self.blurIndexStart;
            _self.enIng = '';
            _self.cnIng = '';
            _self.$nextTick(() => {
                _self.setSelectionRange();
            });
        },
    }
}
